import Link from 'next/link'
import { Button } from '@ui/base/button'
import { landingType } from '@ui/landing'

/**
 * Итог раздела о выгодах: одна мысль крупно и пояснение рядом.
 *
 * Это утверждение сервиса, а не отзыв клиента: настоящей цитаты с разрешением на публикацию у нас
 * нет, а выдуманная в кавычках была бы поддельным отзывом.
 */
export const JoinReview = () => (
  <section className="grid items-center gap-8 py-14 lg:grid-cols-[minmax(0,1.2fr)_minmax(0,1fr)] lg:gap-x-[clamp(32px,6vw,80px)] lg:py-20">
    <p className="max-w-[34ch] text-[clamp(22px,2.4vw,30px)] leading-[1.35] font-medium tracking-[-0.018em] text-balance">
      Поиск клиентов по чатам заменяет одна карточка: продавец приходит с готовым объёмом и вопросом только про цену.
    </p>

    <div className="border-border lg:border-l lg:pl-[clamp(28px,5vw,56px)]">
      <p className={`${landingType.mutedText} text-[16px] leading-[1.65]`}>
        Карточка живёт в общем списке, в разделах по схемам работы и на страницах городов, получает отдельный адрес в
        поиске Яндекса и Google и подтягивает рейтинг с Яндекс Карт и 2ГИС. Вы правите цены и контакты, остальное
        каталог делает сам.
      </p>
      <Button className="mt-6" render={<Link href="/fulfillment/add" />}>
        Разместить фулфилмент
      </Button>
    </div>
  </section>
)
